import { takeEvery, takeLatest, put } from 'redux-saga/effects';
import {
  CREATE,
  LOAD,
  LOAD_ID,
  UPDATE,
  load as loadAction,
} from 'model/payerNotes';
import { create, load, loadById, update as sdkUpdate } from 'sdk/payerNotes';
import { callAction, ORM } from '../util';

export function* reloadAfterCreate({ data }) {
  const { fspId, payerId } = data?.props ?? {};
  if (fspId && payerId) {
    yield put(loadAction({ fspId, payerId }));
  }
}

export default function* saga() {
  yield takeLatest(
    CREATE.ACTION,
    callAction({
      api: create,
      dataName: ORM,
      formatSuccessMessage: () => `Note was added`,
      type: CREATE,
    })
  );

  yield takeLatest(CREATE.SUCCESS, reloadAfterCreate);

  yield takeLatest(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );

  yield takeEvery(
    LOAD_ID.ACTION,
    callAction({
      api: loadById,
      dataName: ORM,
      type: LOAD_ID,
    })
  );

  yield takeLatest(
    UPDATE.ACTION,
    callAction({
      api: sdkUpdate,
      dataName: ORM,
      type: UPDATE,
    })
  );
}
